<script>
import axios from "axios";
import Swal from "sweetalert2";
import SelectWithSearch from "../Common/SelectWithSearch.vue";
import DeleteIcon from "@/views/pages/Dilfoods/Common/icons/DeleteIcon.vue";
import { RP_PRICES, BrandsPath, StorePath } from "../../../../path";

export default {
  props: ["data"],
  components: { SelectWithSearch, DeleteIcon },
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      form: {
        item_id: this.data.id,
        rp_prices: [],
      },
      itemTableFields: [
        "brand",
        "markup_price",
        "selling_price",
        "rp_price",
        "actions",
      ],
      selectedBrand: null,
      selectedStore: [],
      items: [],
    };
  },
  computed: {
    BrandsPath() {
      return BrandsPath;
    },
    StorePath() {
      return StorePath;
    },
  },
  mounted() {
    this.getRpPrices();
  },
  methods: {
    async getRpPrices() {
      try {
        this.form.rp_prices = [];
        let res = await axios.get(this.baseUrl + RP_PRICES.GET_ITEM_PRICES, {
          params: {
            item_id: this.form.item_id,
          },
        });
        if (res.data.status) {
          res.data.data.forEach((f) => {
            this.form.rp_prices.push({
              id: f.id,
              brand_id: f.brand.id,
              brand: f.brand.name,
              store: f.store?.name,
              store_id: f.store?.id,
              rp_price: f.rp_price,
              markup_price: f.markup_price,
              selling_price: f.selling_price,
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteData(v) {
      try {
        this.form.rp_prices.splice(v.index, 1);
        if (v.item.id != undefined || v.item.id != null) {
          let res = await axios.post(
            this.baseUrl + RP_PRICES.DELETE_ITEM_PRICES,
            {
              id: v.item.id,
            }
          );
          if (res.data.status) {
            Swal.fire("success", "", "success");
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async saveAttachBrands() {
      this.form.rp_prices.forEach((e) => {
        delete e.brand;
        delete e.id;
        delete e.store;
      });
      try {
        let res = await axios.post(
          this.baseUrl + RP_PRICES.POST_ITEM_PRICES,
          this.form
        );
        if (res.data.status) {
          Swal.fire("success", "", "success");
        }
        this.$bvModal.hide("bv-brand-tagging");
      } catch (e) {
        console.log(e);
      }
    },
    addBrand() {
      console.log(
        this.form.rp_prices.filter(
          (f) => f.brand_id == this.selectedBrand.id && f.store_id == undefined
        )
      );
      if (this.selectedStore.length > 0) {
        this.selectedStore.forEach((s) => {
          if (
            this.form.rp_prices.filter(
              (f) => f.brand_id == this.selectedBrand.id && f.store == s.name
            ).length == 0
          ) {
            this.form.rp_prices.push({
              brand_id: this.selectedBrand.id,
              brand: this.selectedBrand.label,
              store_id: s.id,
              store: s.name,
              rp_price: 0,
              markup_price: 0,
              selling_price: 0,
            });
          }
        });
      } else if (
        this.form.rp_prices.filter(
          (f) => f.brand_id == this.selectedBrand.id && f.store_id == undefined
        ).length == 0
      ) {
        this.form.rp_prices.push({
          brand_id: this.selectedBrand.id,
          brand: this.selectedBrand.label,
          rp_price: 0,
          markup_price: 0,
          selling_price: 0,
        });
      }
    },
    attachBrand(v) {
      this.selectedBrand = v;
    },
    attachStore(v) {
      this.selectedStore = v;
    },
  },
};
</script>

<template>
  <div>
    <b-row class="mt-4">
      <b-col sm="4">
        <label>Brand</label>
        <SelectWithSearch
          :search_api="BrandsPath.BRAND_SEARCH"
          track_by="id"
          :full_object="true"
          display="label"
          @selectedOption="attachBrand"
        ></SelectWithSearch>
      </b-col>
      <b-col sm="4">
        <label>Store</label>
        <SelectWithSearch
          :multi_select="true"
          :search_api="StorePath.SEARCH_STORE"
          track_by="id"
          :full_object="true"
          display="name"
          :extra_params="'&brand_id=' + selectedBrand?.id"
          @selectedOption="attachStore"
        ></SelectWithSearch>
      </b-col>
      <b-col sm="4">
        <b-button class="mt-4" variant="success" @click="addBrand()"
          >Add</b-button
        >
      </b-col>
    </b-row>
    <b-card>
      <b-card-header>Brand Tags</b-card-header>
      <b-card-body>
        <b-row>
          <b-table :items="form.rp_prices" :fields="itemTableFields">
            <template v-slot:cell(brand)="row">
              <p>{{ row.item.brand }}</p>
              <p v-if="row.item.store">( {{ row.item.store }} )</p>
            </template>
            <template v-slot:cell(markup_price)="row">
              <b-input v-model="row.item.markup_price"></b-input>
            </template>
            <template v-slot:cell(selling_price)="row">
              <b-input v-model="row.item.selling_price"></b-input>
            </template>
            <template v-slot:cell(rp_price)="row">
              <b-input v-model="row.item.rp_price"></b-input>
            </template>
            <template v-slot:cell(actions)="row">
              <div @click="deleteData(row)">
                <DeleteIcon />
              </div>
            </template>
          </b-table>
        </b-row>
        <b-button variant="success" @click="saveAttachBrands">Save</b-button>
      </b-card-body>
    </b-card>
  </div>
</template>
